import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SilkIconWrapperNew } from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelection.style';
import { LazyImage } from 'src/domains/layouts/webview/components/common/lazyLoadingImage/LazyImage';
import {
    ImageDeviceSetType,
    ImageType,
} from 'src/domains/layouts/webview/components/common/lazyLoadingImage/common/ImagePictureHelpers.type';

interface LazyImageSilkPropsType {
    imgBase: ImageType;
    alt?: string;
    className?: string;
    imgDeviceSet?: ImageDeviceSetType;
    placeholder?: boolean;
}

export const LazyImageSilk = observer('LazyImageSilk', (props: LazyImageSilkPropsType) => {
    const { alt, imgBase, className, placeholder, imgDeviceSet } = props;

    if (imgBase.src === '') {
        return <SilkIconWrapperNew />;
    }

    return (
        <LazyImage
            alt={alt}
            imgBase={imgBase}
            className={className}
            placeholder={placeholder}
            imgDeviceSet={imgDeviceSet}
        />
    );
});
